import React, { ReactNode } from "react";

interface ButtonProps {
  type?: 'button' | 'submit' | 'reset';
  children: ReactNode;
  onClick: () => void;
  className?: string;
  style: string;
}

const Button: React.FC<ButtonProps> = ({
  type,
  children,
  onClick,
  className,
  style
}) => {
  return (
    <>
      <button
        type={type}
        onClick={onClick}
        className={`
        ${
          style === "primary"
            ? "flex w-1/2 m-auto mt-5 pt-6 pb-6 items-center border justify-center rounded-2xl bg-primary-btn max-h-16 px-5 py-2.5 text-md font-bold text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300  dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 transition transform duration-150 \n" +
              "               active:scale-90 active:shadow-inner focus:outline-none focus:ring-2 focus:ring-purple-300"
            : ""
        }
        ${
          style === "secondary"
          ? "flex w-1/2 m-auto mt-3 pt-6 pb-6 items-center border justify-center rounded-2xl bg-white max-h-16 px-5 py-2.5 text-md font-bold text-dark-blue hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300  dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 transition transform duration-150 \n" +
              "               active:scale-90 active:shadow-inner"
          : ""
        }
         ${
            style === "scan"
                ? "block w-3/4 mt-24 pt-6 pb-6 m-auto items-center border justify-center rounded-2xl bg-primary-btn px-5 py-2.5 text-md font-bold text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300  dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 transition transform duration-150 \n" +
                "               active:scale-90 active:shadow-inner focus:outline-none focus:ring-2 focus:ring-purple-300"
                : ""
        }
        ${
            style === "checkout"
                ? "block w-1/2 mt-3 pt-6 pb-6 m-auto items-center border justify-center rounded-2xl bg-primary-btn px-5 py-2.5 text-md font-bold text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300  dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 transition transform duration-150 \n" +
                "               active:scale-90 active:shadow-inner focus:outline-none focus:ring-2 focus:ring-purple-300"
                : ""
        }
        ${className}`}
      >
        {children}
      </button>
    </>
  );
};

export default Button;
